import { colors } from 'settings/colors'

export const CounterBadge = ({
  count,
  baseZIndex = 0,
  offset = { top: 0, right: 0 },
}: {
  count: number
  baseZIndex?: number
  offset?: {
    top: number
    right: number
  }
}) => (
  <div
    css={{
      position: 'absolute',
      top: offset.top,
      right: offset.right,
      backgroundColor: colors.white,
      color: colors.midnight,
      borderRadius: 12,
      padding: '3px 8px',
      fontSize: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      zIndex: baseZIndex + 1,
    }}
  >
    {`+${count - 1}`}
  </div>
)
